import { createContext } from "react";
import { RemoteParticipant } from "twilio-video";

export interface IParticipantContext {
  speakerViewParticipants: RemoteParticipant[];
}

export const ParticipantContext = createContext<IParticipantContext>(null!);
